import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

const SOURCE_META = {
  "InfoCamere": "Registro Imprese — anagrafica ufficiale, organi sociali, bilanci depositati.",
  "Gazzetta Ufficiale": "Gazzetta Ufficiale (Parte II) — avvisi legali, insolvenze, liquidazioni.",
  "Tribunali": "Tribunali — contenzioso attivo, parti, tipologia di causa (via aggregatori legal-tech).",
};

export function SourceBadge({ source }) {
  const desc = SOURCE_META[source] || "Fonte ufficiale del registro pubblico.";
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid={`source-badge-${source.replace(/\s+/g, "-").toLowerCase()}`}
            className="inline-flex items-center gap-1 border border-zinc-300 bg-zinc-100 text-zinc-700 text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 rounded-sm hover:bg-zinc-200 transition-colors duration-150"
          >
            <span className="w-1 h-1 rounded-full bg-zinc-500" />
            {source}
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs bg-white border border-zinc-200 text-zinc-800 shadow-lg">
          <p className="text-xs font-medium mb-0.5">Fonte: {source}</p>
          <p className="text-xs text-zinc-500 leading-snug">{desc}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

const RISK_STYLES = {
  safe: "border-green-600 text-green-700 bg-green-50",
  warning: "border-amber-500 text-amber-700 bg-amber-50",
  risk: "border-red-600 text-red-700 bg-red-50",
};
const RISK_LABEL = { safe: "Basso Rischio", warning: "Attenzione", risk: "Alto Rischio" };

export function RiskBadge({ level, className = "" }) {
  const l = level || "safe";
  return (
    <span
      data-testid={`risk-badge-${l}`}
      className={`inline-flex items-center gap-1.5 border text-[11px] font-mono uppercase tracking-wider px-2 py-0.5 rounded-sm ${RISK_STYLES[l]} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${l === "safe" ? "bg-green-600" : l === "warning" ? "bg-amber-500" : "bg-red-600"}`} />
      {RISK_LABEL[l]}
    </span>
  );
}
